export enum ViewStateEnum {
  FILL_MAIN_TRANSACTION_DATA,
  MAKE_REQUEST,
  SHOW_RESULT,
  SHOW_ERROR,
  SHOW_SPINNER
}
